import React from "react";
import Draggable from "react-draggable";
import { Popover, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { getSymbolById, SYMBOL_SIZE } from "../utils/symbolTypes";
import { symbolTransform } from "../utils/symbolTransform";
import { editorCursor } from "../utils/editorCursor";

const DraggableSymbol = ({
  symbol,
  layoutType,
  activeLayoutType,
  position,
  bounds,
  onDragStop,
  onDelete,
  axis,
  // canvasMode (utils/editorCursor.js): the cursor follows 瀏覽 / 編輯模式.
  cursorMode = "edit",
}) => {
  const symbolType = getSymbolById(symbol.symbol_type);
  
  if (!symbolType) {
    return null;
  }

  const isActive = layoutType === activeLayoutType;

  const popoverContent = (
    <div style={{ minWidth: 150 }}>
      <div style={{ marginBottom: 8 }}>
        <strong>{symbolType.name}</strong>
      </div>
      <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>
        <div>類型: {symbolType.category}</div>
        <div>
          位置: {symbol.position_meters?.x?.toFixed(2)}m,{" "}
          {symbol.position_meters?.y?.toFixed(2)}m
        </div>
        {symbol.label && <div>標籤: {symbol.label}</div>}
      </div>
      {onDelete && (
        <Button
          size="small"
          danger
          block
          icon={<DeleteOutlined />}
          onClick={() => onDelete(symbol.id)}
        >
          移除物件
        </Button>
      )}
    </div>
  );

  return (
    <div
      key={symbol.id || `symbol-wrapper-${symbol.symbol_type}`}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        pointerEvents: "none",
      }}
    >
      <Draggable
        axis={axis}
        position={position || { x: 50, y: 50 }}
        onStop={(e, data) => onDragStop(symbol.id, data)}
        bounds={bounds}
        disabled={!isActive}
      >
        <div
          data-glyph="symbol"
          style={{
            cursor: editorCursor(cursorMode, "item", { locked: !isActive }),
            userSelect: "none",
            pointerEvents: "auto",
            display: "block",
            width: SYMBOL_SIZE,
            height: SYMBOL_SIZE,
            padding: 0,
            margin: 0,
            border: "none",
            boxSizing: "border-box",
            lineHeight: 0,
          }}
        >
          <Popover
            content={popoverContent}
            trigger="hover"
            placement="top"
          >
            <div
              style={{
                width: SYMBOL_SIZE,
                height: SYMBOL_SIZE,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: SYMBOL_SIZE - 4,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                borderRadius: "4px",
                border: `2px solid ${symbolType.color}`,
                boxShadow: `0 2px 6px ${symbolType.color}66`,
                transition: "all 0.2s ease",
                transform: symbolTransform(symbol.rotation, 1),
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = symbolTransform(
                  symbol.rotation,
                  1.2,
                );
                e.currentTarget.style.boxShadow = `0 0 0 2px ${symbolType.color}, 0 2px 8px ${symbolType.color}88`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = symbolTransform(
                  symbol.rotation,
                  1,
                );
                e.currentTarget.style.boxShadow = `0 2px 6px ${symbolType.color}66`;
              }}
            >
              {symbolType.icon && <symbolType.icon size={SYMBOL_SIZE - 4} />}
            </div>
          </Popover>
        </div>
      </Draggable>
    </div>
  );
};

export default DraggableSymbol;



